import React from 'react';
import { pressLogos } from '../../data/pressLogos';
import type { PressLogo } from '../../types/landing';
const styleMap: Record<PressLogo['style'], string> = {
  people: 'font-display text-2xl font-bold italic tracking-tight',
  script: 'font-display text-xl italic',
  et: 'font-display text-2xl font-bold',
  box: 'bg-ink px-2 py-1 font-sans text-[9px] font-semibold uppercase tracking-[0.15em] text-white',
  caps: 'font-display text-lg font-semibold uppercase tracking-[0.1em]',
  lower: 'font-body text-lg'
};
export function PressLogos() {
  return <section className="mx-auto mt-16 max-w-5xl px-6" data-id="element-40" data-mp="wd739iftfz6v">
      <div className="border-y border-ink/15 py-6" data-id="element-41" data-mp="1171io9oe1s05">
        <p className="text-center font-sans text-[9px] font-medium uppercase tracking-[0.35em] text-ink/60" data-id="element-42" data-mp="118cmualqx1rs">
          Your wedding may be featured by
        </p>
        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-12 gap-y-4 text-ink/70 md:justify-between" data-id="element-43" data-mp="1a89e8jziseqj">
          {pressLogos.map(logo => <li key={logo.name} className={styleMap[logo.style]} data-id="element-44" data-mp="5pg3md1yrobp">
              {logo.name}
            </li>)}
        </ul>
      </div>
    </section>;
}